// DifficultySelector.jsx - Komponent wyboru poziomu trudności
// Dodaj do src/components/DifficultySelector.jsx

import React from 'react';
import { BookOpen, GraduationCap, Brain, Award, Target } from 'lucide-react';

const DIFFICULTY_LEVELS = [
  {
    value: 1,
    label: 'Klasy 1-4',
    age: '6-10 lat',
    icon: '👶',
    description: 'Bardzo proste pytania, podstawowe pojęcia i fakty',
    promptHint: 'pytania dla ucznia klas 1-4 szkoły podstawowej (6-10 lat)',
    color: 'bg-green-100 text-green-700'
  },
  {
    value: 2,
    label: 'Klasy 5-8',
    age: '10-14 lat',
    icon: '🎒',
    description: 'Pytania na poziomie szkoły podstawowej, wymagające zrozumienia',
    promptHint: 'pytania dla ucznia klas 5-8 szkoły podstawowej (10-14 lat)',
    color: 'bg-blue-100 text-blue-700'
  },
  {
    value: 3,
    label: 'Liceum',
    age: '15-18 lat',
    icon: '📖',
    description: 'Pytania licealne, wymagające analizy i syntezy',
    promptHint: 'pytania dla ucznia liceum (15-18 lat)',
    color: 'bg-purple-100 text-purple-700'
  },
  {
    value: 4,
    label: 'Studia',
    age: '18+ lat',
    icon: '🎓',
    description: 'Pytania akademickie, wymagające myślenia krytycznego',
    promptHint: 'pytania dla studenta (poziom akademicki)',
    color: 'bg-orange-100 text-orange-700'
  },
  {
    value: 5,
    label: 'Ekspert',
    age: 'Zaawansowany',
    icon: '🎯',
    description: 'Bardzo trudne pytania, szczegółowe i wymagające głębokiej wiedzy',
    promptHint: 'bardzo trudne pytania dla eksperta',
    color: 'bg-red-100 text-red-700'
  }
];

export default function DifficultySelector({ value, onChange }) {
  const currentLevel = DIFFICULTY_LEVELS.find(l => l.value === value) || DIFFICULTY_LEVELS[1];
  
  return (
    <div className="bg-white rounded-lg shadow-md p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Brain className="w-5 h-5 text-purple-600" />
        <h3 className="text-lg font-semibold text-gray-800">
          Poziom trudności pytań
        </h3>
      </div>

      {/* Suwak */}
      <div className="mb-6">
        <div className="flex justify-between items-center mb-3">
          {DIFFICULTY_LEVELS.map((level) => (
            <button
              key={level.value}
              onClick={() => onChange(level.value)}
              className={`
                flex flex-col items-center transition-all duration-200
                ${value === level.value ? 'scale-110' : 'scale-90 opacity-60'}
              `}
            >
              <span className="text-3xl mb-1 transition-transform hover:scale-110">
                {level.icon}
              </span>
              <span className="text-xs text-gray-600 text-center whitespace-nowrap">
                {level.label}
              </span>
            </button>
          ))}
        </div>

        {/* Range input */}
        <input
          type="range"
          min="1"
          max="5"
          step="1"
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value))}
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-purple-600"
          style={{
            background: `linear-gradient(to right, 
              #10b981 0%, 
              #3b82f6 25%, 
              #8b5cf6 50%, 
              #f97316 75%, 
              #ef4444 100%)`
          }}
        />
      </div>

      {/* Opis wybranego poziomu */}
      <div className={`${currentLevel.color} rounded-lg p-4 transition-all duration-300`}>
        <div className="flex items-start gap-3">
          <span className="text-4xl">{currentLevel.icon}</span>
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <h4 className="font-semibold text-lg">
                {currentLevel.label}
              </h4>
              <span className="text-sm opacity-75">
                ({currentLevel.age})
              </span>
            </div>
            <p className="text-sm opacity-90">
              {currentLevel.description}
            </p>
          </div>
        </div>
      </div>

      {/* Dodatkowe info */}
      <div className="mt-4 text-xs text-gray-500 text-center">
        💡 Poziom trudności wpływa na złożoność pytań generowanych przez AI
      </div>
    </div>
  );
}

// Export poziomów do użycia w innych miejscach
export { DIFFICULTY_LEVELS };